import { sanitizeFilename, sanitizeString, validateFile } from "./sanitize";

export function buildFormData({ 
    file, 
    filename, 
    uniqueFileId, 
    user, 
    OPENAI_EMBEDDINGS_KEY, 
    MONGODB_Atlas_KEY, 
    dbName, 
    collectionName 
  }) {
  validateFile(file);

  if (!user || !user.username) {
    throw new Error("Invalid user object");
  }

  const safeFilename = sanitizeFilename(filename);
  const safeUser = sanitizeString(user.username);
  const safeDbName = sanitizeString(dbName);
  const safeCollectionName = sanitizeString(collectionName);
  const safeFileId = sanitizeString(uniqueFileId);
  const safeOpenAiKey = sanitizeString(OPENAI_EMBEDDINGS_KEY);
  const safeMongoKey = sanitizeString(MONGODB_Atlas_KEY);

  const fd = new FormData();
  fd.append('files', file);
  fd.append('replaceExisting', 'false');
  fd.append('createNewDocStore', 'false');

  if (file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
    fd.append('loader', JSON.stringify({
      name: 'docxFile',
      config: {
        docxFile: `FILE-STORAGE::["${safeFilename}"]`,
        textSplitter: '',
        metadata: '',
        omitMetadataKeys: ''
      }
    }));
  } else if (file.type === "application/pdf") {
    fd.append('loader', JSON.stringify({
      name: 'pdfFile',
      config: {
        pdfFile: `FILE-STORAGE::["${safeFilename}"]`,
        textSplitter: '',
        metadata: '',
        omitMetadataKeys: ''
      }
    }));
  } else {
    console.warn('Unsupported file type', file.type);
  }


    fd.append('splitter', JSON.stringify({
      name: 'recursiveCharacterTextSplitter',
      config: { chunkSize: 1000, chunkOverlap: 200, "separators": "" }
    }));
  
    fd.append('embedding', JSON.stringify({
      name: 'openAIEmbeddings',
      config: { modelName: 'text-embedding-ada-002', credential: safeOpenAiKey }
    }));
  
    fd.append('vectorStore', JSON.stringify({
      name: 'mongoDBAtlas',
      config: {
        databaseName: safeDbName,
        collectionName: safeCollectionName,
        indexName: 'vector_index',
        textKey: 'text',
        embeddingKey: 'embedding',
        searchType: 'similarity',
        credential: safeMongoKey
      }
    }));
  
    fd.append('metadata', JSON.stringify({
      fileId: safeFileId,
      fileName: filename,
      username: safeUser
    }));
  
    return fd;
  }
  


// WEBPACK FOOTER //
// ./src/utils/formDataBuilder.js